// =============================================================================
// SUGARBOARD — Personnalisations JS (update-safe)
// =============================================================================

// AVERTISSEMENT : Ce fichier cible des sélecteurs internes du thème minisu.
// Sélecteurs concernés : tabs-container, [data-ref="tab"], [data-ref="tabs-panel"],
//   .image-block, .image-block__image, .group
// À vérifier après chaque mise à jour du thème. Voir PATCHES.md.

(function () {

// -----------------------------------------------------------------------------
// Tabs — dissolve image + fade texte
//
// Problèmes identifiés et corrigés :
// 1. new Image() a un décodage async → blank au premier frame même si en cache
//    Fix : div avec background-image → rendu synchrone depuis cache, pas de flash
// 2. Images dans <template> jamais chargées avant le premier clic
//    Fix : précharger toutes les images des onglets au DOMContentLoaded
// -----------------------------------------------------------------------------
function preloadTabImages() {
  document.querySelectorAll('tabs-container [data-ref="tab"] template').forEach((tpl) => {
    tpl.content.querySelectorAll('img[src]').forEach((img) => {
      const pre = new Image();
      pre.src = img.getAttribute('src');
    });
  });
}

function initTabTransitions() {
  let skipNext = false;

  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-ref="tab"]');
    if (!tab || tab.classList.contains('active')) return;

    const container = tab.closest('tabs-container');
    const panel = container?.querySelector('[data-ref="tabs-panel"]');
    if (!panel) return;

    if (skipNext) {
      skipNext = false;
      return;
    }

    e.stopPropagation();

    // 1. Capturer l'image actuelle (src réelle chargée par le navigateur)
    const oldImg   = panel.querySelector('.image-block__image');
    const oldSrc   = oldImg?.currentSrc || oldImg?.src || '';
    const oldRadius = oldImg ? getComputedStyle(oldImg).borderRadius : '0';

    // 2. Injecter le nouveau contenu via tabs.js
    skipNext = true;
    tab.dispatchEvent(new MouseEvent('click', { bubbles: true }));

    // 3. Overlay avec background-image (rendu synchrone depuis cache — pas de flash)
    const newImgBlock = panel.querySelector('.image-block');
    if (newImgBlock && oldSrc) {
      newImgBlock.style.position = 'relative';

      const overlay = document.createElement('div');
      Object.assign(overlay.style, {
        position:           'absolute',
        top:                '0',
        left:               '0',
        right:              '0',
        bottom:             '0',
        backgroundImage:    `url('${oldSrc.replace(/'/g, '%27')}')`,
        backgroundSize:     'cover',
        backgroundPosition: 'center',
        borderRadius:       oldRadius,
        zIndex:             '1',
        pointerEvents:      'none',
      });
      newImgBlock.appendChild(overlay);

      // Fade-out overlay → révèle la nouvelle image dessous
      overlay.animate(
        [{ opacity: 1 }, { opacity: 0 }],
        { duration: 500, easing: 'ease', fill: 'forwards' }
      ).finished.then(() => {
        overlay.remove();
        newImgBlock.style.removeProperty('position');
      });
    }

    // 4. Fade-in texte uniquement (pas d'image)
    panel.querySelectorAll('.group').forEach((el) => {
      el.animate(
        [
          { opacity: 0, transform: 'translateY(6px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ],
        { duration: 350, easing: 'ease', delay: 80, fill: 'backwards' }
      );
    });

  }, true);
}

// -----------------------------------------------------------------------------
// Vidéos — retrait des contrôles natifs sur TOUTES les vidéos du site
//
// Le filtre Shopify `video_tag` force l'attribut `controls` même quand il est
// désactivé, et deferred-media réinjecte les <video> au lancement. On retire
// `controls` du DOM partout, y compris sur les vidéos ajoutées dynamiquement.
// -----------------------------------------------------------------------------
function stripVideoControls(node) {
  if (!node || node.nodeType !== 1) return;
  if (node.tagName === 'VIDEO') {
    node.removeAttribute('controls');
    node.controls = false;
  }
  if (node.querySelectorAll) {
    node.querySelectorAll('video').forEach((video) => {
      video.removeAttribute('controls');
      video.controls = false;
    });
  }
}

stripVideoControls(document.documentElement);

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes') {
      stripVideoControls(mutation.target);
    } else {
      mutation.addedNodes.forEach(stripVideoControls);
    }
  });
}).observe(document.documentElement, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['controls'],
});

document.addEventListener('DOMContentLoaded', () => {
  preloadTabImages();
  initTabTransitions();
  syncHeaderHeight();
});

// Propage --header-height du .header--sticky vers :root
// pour que scroll-padding-top fonctionne sur les ancres natives.
function syncHeaderHeight() {
  var header = document.querySelector('.header--sticky');
  if (!header) return;
  var h = getComputedStyle(header).getPropertyValue('--header-height').trim();
  if (h) document.documentElement.style.setProperty('--header-height', h);
}

// Intercept en phase capture (avant le routeur SPA du thème) tous les liens
// vers un ID de section Shopify (#shopify-section-...) et force le smooth scroll
// avec compensation du header sticky.
// Fallback suffix : si l'ID exact a changé (resource ID Shopify instable),
// on retrouve l'élément par la section key seule ([id$="__section_key"]).
document.addEventListener('click', function (e) {
  var link = e.target.closest('a[href^="#shopify-section-"]');
  if (!link) return;
  var targetId = link.getAttribute('href').slice(1);
  var target = document.getElementById(targetId);
  if (!target) {
    var suffix = targetId.indexOf('__') !== -1 ? targetId.slice(targetId.indexOf('__')) : null;
    if (suffix) target = document.querySelector('[id$="' + suffix + '"]');
  }
  if (!target) return;
  e.preventDefault();
  e.stopPropagation();
  var h = document.querySelector('.header--sticky');
  var offset = h ? h.getBoundingClientRect().height + 8 : 8;
  var top = target.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top: top, behavior: 'smooth' });
}, true);

})();
